'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Loading": "Polaris-Autocomplete__Loading",
  "SectionWrapper": "Polaris-Autocomplete__SectionWrapper"
};

exports.default = styles;
